export default __webpack_public_path__ + "static/media/billy.65c49a3b.jpg";